/* eslint-disable no-tabs */
import React from 'react';
import PropTypes from 'prop-types';

const TrashIcon = ({ fill, style, ...rest }) => (
  <svg
    {...rest}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 15.713 22.031"
    style={{ enableBackground: 'new 0 0 32.313 14.533', ...style }}
    xmlSpace="preserve"
  >
    <g id="Group_50" transform="translate(-1136 -220)">
      <path
        id="Path_1357"
        fill={fill}
        d="M1137.877,240.983c0.013,0.576,0.479,1.038,1.055,1.048h9.853
		c0.576-0.01,1.042-0.472,1.055-1.048l0.7-15.393h-13.37L1137.877,240.983z M1146.087,229.414c-0.004-0.241,0.188-0.44,0.429-0.444
		h0.686c0.241,0.004,0.433,0.203,0.429,0.444v8.794c0.004,0.241-0.188,0.44-0.429,0.444h-0.686
		c-0.241-0.004-0.433-0.203-0.429-0.444V229.414z M1143.087,229.414c-0.004-0.241,0.188-0.439,0.428-0.444h0.686
		c0.24,0.005,0.432,0.203,0.428,0.444v8.794c0.004,0.241-0.188,0.439-0.428,0.444h-0.686c-0.241-0.004-0.432-0.203-0.428-0.444
		c0,0,0,0,0,0V229.414z M1140.087,229.414c-0.004-0.241,0.188-0.44,0.429-0.444h0.686c0.241,0.004,0.433,0.203,0.429,0.444v8.794
		c0.004,0.241-0.188,0.44-0.429,0.444h-0.686c-0.241-0.004-0.433-0.203-0.429-0.444V229.414z"
      />
      <path
        id="Path_1358"
        fill={fill}
        d="M1151.048,221.12h-4.569v-0.891c0.002-0.124-0.098-0.227-0.222-0.229h-4.8
		c-0.124,0.002-0.224,0.105-0.222,0.229v0.89h-4.569c-0.373,0.005-0.672,0.313-0.666,0.686c0,0,0,0.001,0,0.001v2.156h15.713v-2.156
		C1151.719,221.433,1151.421,221.126,1151.048,221.12C1151.047,221.12,1151.047,221.12,1151.048,221.12L1151.048,221.12z"
      />
    </g>
  </svg>
);

TrashIcon.propTypes = {
  fill: PropTypes.string,
  style: PropTypes.object,
  rest: PropTypes.object,
};

TrashIcon.defaultProps = {
  fill: '#FFFFFF',
  style: {},
  rest: {},
};

export default TrashIcon;



// WEBPACK FOOTER //
// ./src/assets/TrashIcon.jsx